import { Download } from 'react-bootstrap-icons'
import { Dropdown } from 'react-bootstrap'
import { externalUrls } from 'consts';
import { useState } from 'react';

interface DownloadReportButtonProps {
  id: number
  formats: Array<{ id: string; name: string }>
  reportQueryString: string,
  isLoaded?: Function
}

const DownloadReportButton: React.FunctionComponent<DownloadReportButtonProps> = (
  props: DownloadReportButtonProps,
) => {

  const [isDownloadInProcess, setIsDownloadInProcess] = useState<boolean>(false)

  const download = (url, filename)  => {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.addEventListener('click', () => {
      setTimeout(() => setIsDownloadInProcess(false), 15000); 
    });
    link.click();
    document.body.removeChild(link);
  }

  const  getExportAction = (format: string): string  => {
    switch (format.toLowerCase()) {
      case 'xls':
        return externalUrls.visualizeReportPrintXls
      case 'csv':
        return externalUrls.visualizeReportPrintCsv
      default:
        return externalUrls.visualizeReportPrint
    }
  }
  
  return (
    <>
      <Dropdown className='download'>
        <Dropdown.Toggle id='dropdown-download' variant='filter'>
                {isDownloadInProcess ? (
                  <>
                    <span
                      className='spinner-border spinner-border-sm'
                      role='status'
                      aria-hidden='true'
                    ></span>
                    &nbsp;
                  </>
                ) : (
                  <Download /> 
                )}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <div className='download-options'>
            <Dropdown.Header>Available Formats</Dropdown.Header>
            {props.formats.map((option: { id: string; name: string }, index: any) => {
              return (
                <Dropdown.Item
                  key={index}
                  eventKey={index}
                  onClick={(e) => {
                    setIsDownloadInProcess(true)
                    const format = option.name.toLowerCase()
                    const urlWithAction = getExportAction(format)
                    const urlDownload = urlWithAction + props.reportQueryString + '&export_format=' + option.name.toLowerCase()
                    download(urlDownload, `report-${props.id}.` + format)
                  }}
                >
                  {option.name}
                </Dropdown.Item>
              )
            })}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </>
  )
}

export default DownloadReportButton
